import {migratePropertyBetweenStyleItems, computeAlign, setProperty} from '../utils'
import type {ComponentProps} from '../types'
import type {StyleRef} from '@wix/document-services-types'

export const migrateMegaMenuContainerItemLayout = (
    stylableHorizontalMenuProps: ComponentProps,
    menuStyleItem: StyleRef,
    megaMenuContainerItemStyleItem: StyleRef
) => {
    const {isContainerStretched} = stylableHorizontalMenuProps

    migratePropertyBetweenStyleItems({
        fromKey: 'dropdown-container---containerMarginTop',
        toKey: 'space-above',
        from: menuStyleItem,
        to: megaMenuContainerItemStyleItem
    })

    migratePropertyBetweenStyleItems({
        fromKey: 'mega-menu-container-position-box-margin-left',
        toKey: 'horizontal-margin',
        from: menuStyleItem,
        to: megaMenuContainerItemStyleItem
    })

    if (isContainerStretched) {
        setProperty({
            key: 'anchor',
            value: 'screen',
            styleItem: megaMenuContainerItemStyleItem
        })
        setProperty({
            key: 'align',
            value: 'start',
            styleItem: megaMenuContainerItemStyleItem
        })
    } else {
        setProperty({
            key: 'anchor',
            value: 'menuCustomWidth',
            styleItem: megaMenuContainerItemStyleItem
        })
        const normalizedAlign = computeAlign(
            menuStyleItem.style.properties['menu-direction'],
            menuStyleItem.style.properties['mega-menu-wrapper-justify-content']
        )

        if (normalizedAlign) {
            setProperty({
                key: 'align',
                value: normalizedAlign,
                styleItem: megaMenuContainerItemStyleItem
            })
        }
    }
}
